import React, { useEffect, useState } from "react";
import { classNames } from "@greeter/util";

import css from "./DescriptiveText.module.scss";

const DescriptiveText: React.FC<React.HTMLProps<HTMLParagraphElement>> = ({className, ...props })  => {
    return (
        <p
            {...classNames(css.DescriptiveText, className)}
            {...props}
        />
    );
};

export default DescriptiveText;
